/**
 * Split an array into batches of a given size
 */
export const batchArray = <T>(arr: T[], size: number): T[][] => {
  const batches: T[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    batches.push(arr.slice(i, i + size));
  }
  return batches;
};
